import { refineryVolume } from "../data/refinery";

const state = {
  data: refineryVolume,
};
const getters = {
  getterRefinery: (state) => () => {
      return state.data
  },
};
const mutations = {
  SET_REFINERY: (state, payload) => {
    state.data = payload;
  },
};

const actions = {
  setRefinery: ({ commit }, payload) => {
    commit("SET_REFINERY", payload);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
